const sharedCardData = {
  1: {
    name: "Capital One Venture X",
    image: "/Cards/capitaloneventure.avif",
    annualFee: 395,
    hotOffer: true,
    applyLink: "https://i.capitalone.com/JBg2vw8TQ",
  },
  2: {
    name: "AMEX Hilton Aspire Card",
    image: "/Cards/hilton.webp",
    annualFee: 550,
    hotOffer: false,
    applyLink:
      "https://americanexpress.com/en-us/referral/hilton-honors?ref=DONGFZDTgf&xl=cp15",
  },
  3: {
    name: "Marriott Bonvoy Brilliant® American Express® Card",
    image: "/Cards/marriott.avif",
    annualFee: 650,
    hotOffer: false,
    applyLink:
      "https://americanexpress.com/en-us/referral/marriott-bonvoy?ref=DONGFZsu05&xl=cp01",
  },
  4: {
    name: "AMEX Gold Card",
    image: "/Cards/amexgold.avif",
    annualFee: 325,
    hotOffer: true,
    applyLink:
      "https://americanexpress.com/en-us/referral/gold-card?ref=DONGFZYnJj&XLINK=MYCP",
  },
  5: {
    name: "Chase Sapphire Preferred®",
    image: "/Cards/chasecsp.png",
    annualFee: 95,
    hotOffer: false,
    applyLink: "https://www.referyourchasecard.com/19t/XWMN16AZGU",
  },
  6: {
    name: "Chase Sapphire Reserve",
    image: "/Cards/chasecsr.png",
    annualFee: 795,
    hotOffer: true,
    applyLink: "https://www.referyourchasecard.com/19t/O7Z5DIESE7",
  },
  7: {
    name: "Chase Amazon Prime Visa",
    image: "/Cards/chaseamazon.png",
    annualFee: 0,
    hotOffer: true,
    applyLink:
      "https://www.amazon.com/dp/BT00LN946S?externalReferenceId=f4471963-ae19-4ba8-90f3-3febda2657a3",
  },
  8: {
    name: "Chase Southwest Rapid Rewards Priority Card",
    image: "/Cards/chasesouthwest.png",
    annualFee: 229,
    hotOffer: false,
    applyLink: "https://www.referyourchasecard.com/226c/60A3VEYTHF",
  },
  9: {
    name: "Chase Southwest Rewards Performance Business Card",
    image: "/Cards/chasesouthwestbusiness.png",
    annualFee: 299,
    hotOffer: false,
    applyLink: "https://www.referyourchasecard.com/226c/IRD5KZELCC",
  },
  10: {
    name: "Bank of America® Customized Cash Rewards",
    image: "/Cards/bankofamerica.jpeg",
    annualFee: 0,
    hotOffer: false,
    applyLink:
      "https://www.bankofamerica.com/credit-cards/products/cash-back-credit-card/",
  },
  11: {
    name: "Fidelity Visa Signature Rewards",
    image: "/Cards/fidelity.png",
    annualFee: 0,
    hotOffer: false,
    applyLink: "https://www.fidelity.com/go/visa-signature-rewards-1502",
  },
  12: {
    name: "Chase Freedom Flex",
    image: "/Cards/chasefreedom.png",
    annualFee: 0,
    hotOffer: false,
    applyLink: "https://www.referyourchasecard.com/18s/H8PV7FBNN3",
  },
  13: {
    name: "Bilt Credit Card",
    image: "/Cards/Bilt.png",
    annualFee: 0,
    hotOffer: false,
    applyLink: "",
  },
  14: {
    name: "AMEX Platinum Card",
    image: "/Cards/amexplatinum.avif",
    annualFee: 895,
    hotOffer: true,
    applyLink:
      "https://americanexpress.com/en-us/referral/platinum-card?ref=YUANZugnx&xl=cp10o6",
  },
}

export default sharedCardData
